export const ADD_HOTEL_INFO = 'ADD_HOTEL_INFO';
export const ADD_ROOMS = 'ADD_ROOMS';
